import { connect } from 'react-redux'
import Statistics from './Statistics'
import { userCompaniesSelector } from '../Settings/store/SettingsSelectors'
import { IGlobalState } from '../../Root/store/appReducer'
import { hasRoleInCompany } from '../../common/auth/authSelectors'
import { CompanyId, Role } from '../../services/api.types'
import { getStatisticsSelectedCompanyId } from '../Statistics/store/StatisticsSelectors'
import { setSelectedCompanyId } from '../Statistics/store/StatisticsActions'

const mapStateToProps = (state: IGlobalState, ownProps: any) => ({
  tab: ownProps.match.params.tab || null,
  userCompanies: userCompaniesSelector(state),
  selectedCompanyId: getStatisticsSelectedCompanyId(state),
  hasRoleInCompany: (companyId: CompanyId, role: Role) => hasRoleInCompany(state, companyId, role),
})

const mapDispatchToProps = {
  setSelectedCompanyId,
}

export default connect(mapStateToProps, mapDispatchToProps)(Statistics)
